<template>
  <div class="view-header">{{header}}</div>
</template>

<script>
  export default {
    name: 'ViewHeader',
    props: {
      header: String,
    },
  };
</script>

<style lang="scss" scoped>
  .view-header {
    @include fontSize(24px);
    font-weight: normal;
    margin-bottom: 32px;
    padding: 8px 0 16px 16px;
    border-bottom: 1px solid #333333;

    @include mobile {
      text-align: center;
    }

    @at-root .high-contrast & {
      border-color: white;
      color: white;
    }
  }
</style>
